import { render, staticRenderFns } from "./EditHistory.vue?vue&type=template&id=0ccbbfa2&scoped=true&"
import script from "./EditHistory.vue?vue&type=script&lang=ts&"
export * from "./EditHistory.vue?vue&type=script&lang=ts&"
import style0 from "./EditHistory.vue?vue&type=style&index=0&id=0ccbbfa2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccbbfa2",
  null
  
)

export default component.exports